import { useState, useEffect } from 'react'
import { get } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import FormLoader from '../../../../components/loader/FormLoader'
import { Icon } from '@iconify/react'
import CreateUserRate from './aggregatorRate/CreateAggregatorRate'
import DeleteZone from './aggregatorRate/DeleteAggregatorZone'
import FullLoader from '../../../../components/loader/FullLoader'

function AggregatorRates() {
  const baseURL = (import.meta as any).env.VITE_BASE_URL
  const { notify, profile } = useGlobalContext()
  const [zoneList, setZoneList] = useState<any>({ data: [] })
  const [loading, setLoading] = useState(true)
  const [selectedZone, setSelectedZone] = useState('export')
  const [showCreate, setShowCreate] = useState(false)
  const [showDelete, setShowDelete] = useState<any>(null)
  const [selectedZoneData, setSelectedZoneData] = useState<any>(null)
  const [downloading, setDownloading] = useState(false)

  function fetchRates() {
    setLoading(true)
    let url = `zonerates/aggregator/fetch`
    get(url)
      .then((result: any) => {
        if (result.status === 200) {
          setZoneList(result.data)
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }
  useEffect(() => {
    fetchRates()
  }, [])
  function selectZoneX(data: any) {
    setSelectedZoneData(data)
    setShowCreate(true)
  }
  const handlePriceDownload = async (role: string) => {
    const token = sessionStorage.getItem('token')
    let apiUrl = `${baseURL}/zonerates/price-rate`
    try {
      // Make an API request to fetch the Excel file
      setDownloading(true)
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ role: role }), // Replace 'admin' with the appropriate role
      })

      if (!response.ok) {
        setDownloading(false)
        throw new Error('Failed to download file')
      }

      // Convert the response to a Blob
      const blob = await response.blob()

      // Extract the filename from the "Content-Disposition" header
      const fileName = `Price_Rates-${new Date().toLocaleDateString()}`

      // Create a download link for the Blob
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName // Use the filename from the backend
      document.body.appendChild(a) // Append to the DOM
      a.click() // Trigger the download
      a.remove() // Clean up
      window.URL.revokeObjectURL(url) // Release memory
      setDownloading(false)
    } catch (error) {
      console.error('Error downloading the file:', error)
    }
  }
  const handleImportPriceDownload = async (role: string) => {
    const token = sessionStorage.getItem('token')
    let apiUrl = `${baseURL}/zonerates/import-price-rate`
    try {
      // Make an API request to fetch the Excel file
      setDownloading(true)
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ role: role }), // Replace 'admin' with the appropriate role
      })

      if (!response.ok) {
        setDownloading(false)
        throw new Error('Failed to download file')
      }

      // Convert the response to a Blob
      const blob = await response.blob()

      // Extract the filename from the "Content-Disposition" header
      const fileName = `Import_Price_Rates-${new Date().toLocaleDateString()}`

      // Create a download link for the Blob
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName // Use the filename from the backend
      document.body.appendChild(a) // Append to the DOM
      a.click() // Trigger the download
      a.remove() // Clean up
      window.URL.revokeObjectURL(url) // Release memory
      setDownloading(false)
    } catch (error) {
      console.error('Error downloading the file:', error)
    }
  }
  return (
    <div className='home'>
      {downloading && <FullLoader />}
      <div className='home_tag flex justify-between'>
        <span></span>
        <div className='flex buttons'>
          {(profile?.role === 'super admin' ||
            profile?.role === 'manager' ||
            profile?.role === 'customer service') && (
            <>
              <button onClick={() => handlePriceDownload('aggregator')}>
                Print Export Price sheet
              </button>
              <button onClick={() => handleImportPriceDownload('aggregator')}>
                Print Import Price sheet
              </button>
            </>
          )}

          {profile?.role === 'super admin' && (
            <button
              onClick={() => {
                setShowCreate(true)
                setSelectedZoneData(null)
              }}
            >
              Create Aggregator Rates
            </button>
          )}
        </div>
      </div>
      <div className='home_tables'>
        <div className='left'>
          <div className='switch'>
            <div className='vut'>
              <div
                className={selectedZone === 'export' ? 'tabx activex' : 'tabx'}
                onClick={() => setSelectedZone('export')}
              >
                Export
              </div>
              <div
                className={selectedZone === 'import' ? 'tabx activex' : 'tabx'}
                onClick={() => setSelectedZone('import')}
              >
                Import
              </div>
              <div
                className={
                  selectedZone === 'domestic' ? 'tabx activex ' : 'tabx'
                }
                onClick={() => setSelectedZone('domestic')}
              >
                Domestic
              </div>
            </div>
          </div>
          {loading ? (
            <FormLoader position='center' />
          ) : (
            <>
              {zoneList.length > 0 ? (
                <>
                  <table>
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Type</th>
                        <th>Zone</th>
                        <th>Document</th>
                        <th>Min</th>
                        <th>Max</th>
                        <th>Charge</th>
                        <th></th>
                      </tr>
                    </thead>
                    {selectedZone === 'export' ? (
                      <tbody>
                        {zoneList
                          .filter((item: any) => item.type === 'export')
                          .map((item: any, i: number) => (
                            <tr key={item._id}>
                              <td>{1 + i}</td>
                              <td className='count'>{item.type}</td>
                              <td>{item.zone}</td>
                              <td className='count'>{`${item.document}`}</td>
                              <td> {item.min} kg</td>
                              <td> {item.max} kg</td>
                              <td>{item.charge.toLocaleString()} %</td>
                              <td className='icons'>
                                {profile?.role === 'super admin' && (
                                  <>
                                    <Icon
                                      icon='fa-solid:edit'
                                      className='put'
                                      onClick={() => selectZoneX(item)}
                                    />
                                    <Icon
                                      icon='fa-solid:trash'
                                      className='del'
                                      onClick={() => setShowDelete(item._id)}
                                    />
                                  </>
                                )}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    ) : (
                      <>
                        {selectedZone === 'import' ? (
                          <tbody>
                            {zoneList
                              .filter((item: any) => item.type === 'import')
                              .map((item: any, i: number) => (
                                <tr key={item._id}>
                                  <td>{1 + i}</td>
                                  <td className='count'>{item.type}</td>
                                  <td>{item.zone}</td>
                                  <td className='count'>{`${item.document}`}</td>
                                  <td> {item.min} kg</td>
                                  <td> {item.max} kg</td>
                                  <td>{item.charge.toLocaleString()} %</td>
                                  <td className='icons'>
                                    {profile?.role === 'super admin' && (
                                      <>
                                        <Icon
                                          icon='fa-solid:edit'
                                          className='put'
                                          onClick={() => selectZoneX(item)}
                                        />
                                        <Icon
                                          icon='fa-solid:trash'
                                          className='del'
                                          onClick={() =>
                                            setShowDelete(item._id)
                                          }
                                        />
                                      </>
                                    )}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        ) : (
                          <tbody>
                            {zoneList
                              .filter((item: any) => item.type === 'domestic')
                              .map((item: any, i: number) => (
                                <tr key={item._id}>
                                  <td>{1 + i}</td>
                                  <td className='count'>{item.type}</td>
                                  <td>{item.zone}</td>
                                  <td className='count'>{`${item.document}`}</td>
                                  <td> {item.min} kg</td>
                                  <td> {item.max} kg</td>
                                  <td>{item.charge.toLocaleString()} %</td>
                                  <td className='icons'>
                                    {profile?.role === 'super admin' && (
                                      <>
                                        <Icon
                                          icon='fa-solid:edit'
                                          className='put'
                                          onClick={() => selectZoneX(item)}
                                        />
                                        <Icon
                                          icon='fa-solid:trash'
                                          className='del'
                                          onClick={() =>
                                            setShowDelete(item._id)
                                          }
                                        />
                                      </>
                                    )}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        )}
                      </>
                    )}
                  </table>
                </>
              ) : (
                <div className='empty flex justify-center'>
                  <div className='empty-cover'>
                    <Icon icon='mdi:sack-percent' />
                    <h1>No Aggregator Rates To Show</h1>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {showCreate && (
        <CreateUserRate
          setShowCreate={setShowCreate}
          fetchRates={fetchRates}
          selectedZoneData={selectedZoneData}
        />
      )}
      {showDelete && (
        <DeleteZone
          showDelete={showDelete}
          setShowDelete={setShowDelete}
          fetchRates={fetchRates}
        />
      )}
    </div>
  )
}

export default AggregatorRates
